import { useContext } from 'react';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { ThemeContext } from '@forma/forma-ui-kit';
import { RequestDemo } from '@/components/blocks/RequestDemo';
import SocialMediaSlider from '@/components/blocksMiniBuisness/SocialMediaSlider';
import ButtonsBlock from '@/components/blocks/ButtonsBlock/ButtonsBlock';
import AdvantagesBanner3 from '@/components/blocks/AdvantagesBanner3';
import RequestDemoBanner from '@/components/blocks/RequestDemoBanner';
import RegisterBanner from '@/components/blocks/RegisterBanner';
import { MainContext } from '@/context/MainContext';
import MetaTags from '@/components/MetaTags';
import useMetaTags from '@/hooks/useMetaTags';
import { queries } from '@/helpers/api';
import getHeadersFromServer from '@/helpers/getHeadersFromServer';

import styles from './Request.module.css';

export const getServerSideProps = async ({ req, res, params }) => {
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=14400, stale-while-revalidate=10'
  );
  const mainData = await queries.getMainData(params.locale);
  const pageData = await queries.getPageData(params.locale, 'request');
  const timezones = await queries.getTimezones(params.locale);
  const headersParse = await getHeadersFromServer(req);
  return {
    props: {
      initialState: {
        main: mainData,
        timezones: timezones
      },
      pageData,
      headersParse,
      ...(await serverSideTranslations(params.locale, ['common', 'uikit'])),
    },
  };
};

const RequestPage = ({ pageData }) => {
  const { t } = useTranslation();

  const metaData = {
    title: t('meta_titles.request'),
    description: t('meta_descriptions.request'),
    keywords: t('main_keywords'),
  };
  const { main } = useContext(MainContext);
  const { lang } = useContext(ThemeContext);
  useMetaTags({ lang, ...metaData });

  const { media, advantages, request_demo } = pageData;

  return (
    <div>
      <Head>
        <title>{metaData.title}</title>
        <MetaTags {...metaData} />
      </Head>

      <RequestDemo />
      <SocialMediaSlider
        {...media}
        className={styles.slider}
      />
      <ButtonsBlock
        title="Сферы применения"
        items={main?.solutions}
      />
      <AdvantagesBanner3
        {...advantages}
        variant="white"
        modalType="demo"
        buttonText="Активировать демо-доступ"
      />
      <RequestDemoBanner
        {...request_demo}
        variant="white"
      />
      <RegisterBanner />
    </div>
  );
};

export default RequestPage;
